$(document).on('ready turbolinks:load', function() {
  $("select[name='user_type_setting[reservation_start_type]']").on('change', function() {
    var val = $("select[name='user_type_setting[reservation_start_type]']").val();
    if (val == "month_days") {
      $(".user_type_setting_reservation_start_X_value").slideDown();
    } else {
      $(".user_type_setting_reservation_start_X_value").slideUp();
    }
  });
  $("select[name='user_type_setting[reservation_start_type]']").trigger('change');
});
